export default __webpack_public_path__ + "static/media/Atarev.759c6cbd.png";